import React, { Component } from 'react'
import FixedView from '../FixedView'
import Collapsible from 'react-collapsible'
import { checkPermission, checkTranslation, translate } from '../../utils/useful'
import FramesPlusBut from './FramesPlusBut'
import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons';

export default class StaticFrame extends Component {
    state = {
        collapses: {},
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? false : !this.state.collapses[key]
        this.setState({ collapses })
    }

    changeFrame = (item) => {
        // this.props.changePage(item)
        // console.log('item is', item)
        this.props.functionsHandler(null, 'changePage', [(item.key ?? item._id)])
        this.framesOptionsList.hideView()
    }

    handelFunction = (mfunction) => {
        if (this[mfunction]) {
            this[mfunction]()
        }
    }

    addPage = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'pages', 'new'])
        this.framesOptionsList.hideView()
    }

    addCollection = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'collections', 'new'])
        this.framesOptionsList.hideView()
    }



    iconSelector(type) {
        switch (type) {
            case 'collection':
                return '/assets/icons/applets/database.png'

            case 'messenger':
                return '/assets/icons/portals/chat (2).png'

            case 'drive':
                return '/assets/icons/applets/drive.png'

            case 'folder':
                return '/assets/icons/folder (1).png'

            case 'page':
                return '/assets/icons/applets/notebook.png'



            default:
                return '/assets/icons/useful/pages.png'
        }
    }



    showChildren = (parent, data, level) => {
        return (
            <div className={''}>

                {data?.map((item, index) => {
                    // console.log('item.parents',item.parents[item.parents.length - 1],parent,item)
                    if (item.parents &&
                        (checkPermission(this.props.permissions, `collection.${item._id}.view`)) &&
                        // item.parents[item.parents.length - 1] == parent && !item.hideInDashboard && item.userperspective)
                        item.parents[item.parents.length - 1] == parent && !item.hideInDashboard && !item.userperspective) {

                        let hasChildren = this.props.frames.filter((a) => Array.isArray(a.parents) && a.parents[a.parents.length - 1] == item._id).length > 0

                        return (
                            <div className={'w-100 ' + (level > 0 ? ' pld-2' : '')} key={index}>
                                <div className='flexcb w-100 p-2 hover-gray-no-filter br-5  transition-all'>
                                    <div className={"flexcb w-100 "}>
                                        <button onClick={() => { this.changeFrame(item) }} className='flexc w-100'>



                                            <div className='flexcc pld-1'>
                                                <img className="transition-all " src={item.icon ?? this.iconSelector(item.type)} height={20} />
                                            </div>

                                            {/* {item.type == 'folder' && (
                                                <div className='flexcc pld-1'>
                                                    <img className="transition-all " src={'/assets/icons/folder (1).png'} height={16} />
                                                </div>
                                            )} */}

                                            {/* {item.type == 'page' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#007aff20', color: '#007aff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>D</p>
                                                    </div>
                                                    
                                                </div>
                                            )}
                                            {item.type == 'recordClassifier' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#007aff20', color: '#007aff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>S</p>
                                                    </div>
                                                    
                                                </div>
                                            )}
                                            {item.mode == 'planner' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#7a00ff20', color: '#7a00ff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>P</p>
                                                    </div>
                                                </div>
                                            )}
                                            {item.mode == 'tasklist' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#7a00ff20', color: '#7a00ff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>T</p>
                                                    </div>
                                                </div>
                                            )} */}
                                            <div className={'mld-3'}>
                                                <p className='font-size-12 text-semibold main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                            </div>
                                        </button>
                                        <div>
                                            {hasChildren && (
                                                <div className="flexcc" >
                                                    <FramesPlusBut width={this.props.width} colors={this.props.colors} frame={item._id} functionsHandler={this.props.functionsHandler} updateFrames={this.props.updateFrames} variables={this.props.variables} />
                                                    <button onClick={() => this.changeCollapse(item._id)}>
                                                        <img className={"transition flexcc " + ((this.state.collapses[item._id] == null || this.state.collapses[item._id] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' alt='' />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className={'w-100 ' + ((this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]) ? "Collapsible-is-open" : '')}> */}
                                <Collapsible open={this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]}>
                                    {this.showChildren(item._id, data, level + 1)}
                                </Collapsible>
                                {/* </div> */}
                            </div>
                        )
                    }
                })}
            </div>
        )
    }



    render() {

        let colors = this.props.colors

        return (
            <div className='mld-3'>

                {!this.props.userPerspective && (
                    <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                        <div className={'flexcc pld-3 prd-4 py-1 br-5  ' + (colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg')}>
                            <div className='flexcc mrd-1'>
                                <img className={colors?.iconInvert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                            </div>
                            <p className='font-size-14 ' style={{ color: colors.textColor }}>{checkTranslation(this.props.currentFrame?.name) ?? translate('Frames')}</p>
                        </div>
                    </button>
                )}
                <FixedView width={this.props.width} zIndex={40} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className="mt-0">
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <button onClick={() => this.changeFrame('')} className='flexc w-100 p-2 hover-gray2 br-5 mb-2' >
                                        <div className="flexc">
                                            <img className="transition" src={'/images/icons/gaming-video.png'} width={22} />
                                            <div className='d-flex flex-column mld-3'>
                                                <p className={'font-size-12 text-semibold main-c3'}>{translate("Dashboard")}</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>

                                <div className='py-1'>
                                    {this.props.frames?.map((section, i) => {
                                        let checkParent
                                        if (section.parents && section.parents.length != 0) {

                                            this.props.frames.map((sec) => {
                                                if (section.parents.includes(sec._id)) {
                                                    checkParent = true
                                                }
                                            })
                                        }

                                        let show = section
                                            && (checkPermission(this.props.permissions, `collection.${section._id}.view`))
                                            && (section.parents == null || section.parents.length == 0 || !checkParent) && !section.userperspective



                                        if (show) {

                                            let hasAdd = true
                                            let hasChildren = this.props.frames.filter((a) => Array.isArray(a.parents) && a.parents[a.parents.length - 1] == section._id).length > 0

                                            return (
                                                <div key={section._id} className="w-100 " style={{ borderBottom: '0px solid #f6f6f6' }}>
                                                    <div className="flexcb w-100 px-2   hover-gray-no-filter br-5  transition-all "  >
                                                        <button onClick={() => this.changeFrame(section)} className="py-2 flexc text-start flex-1">
                                                            <img className="transition-all" src={section.icon ?? this.iconSelector(section.type)} width={22} alt='' />
                                                            <div className='mld-3'>
                                                                <p className="font-size-12 main-c3 text-bold " style={{}}>{checkTranslation(section.name ?? section.title)}</p>
                                                            </div>
                                                        </button>

                                                        <div className='flexc'>
                                                            {hasAdd && (
                                                                <FramesPlusBut colors={this.props.colors} width={this.props.width} type={'frame'} frame={section._id} functionsHandler={this.props.functionsHandler} updateFrames={this.props.updateFrames} variables={this.props.variables} />
                                                            )}
                                                            {hasChildren && (
                                                                <button className="" onClick={() => this.changeCollapse(section._id)}>
                                                                    <img className={"transition flexcc " + ((this.state.collapses[section._id] == null || this.state.collapses[section._id] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' alt='' />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <Collapsible open={this.state.collapses[section._id] == null ? true : this.state.collapses[section._id]}>
                                                        {this.showChildren(section._id, this.props.frames, 1)}
                                                    </Collapsible>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>

                                <div className=' text-semibold  py-1' style={{ borderTop: '1px solid #f0f0f0' }}>
                                    <button className='pt-2 pb-2 px-2 w-100 flexcb hover-gray-no-filter br-5  transition-all'>
                                        <div className='flexc'>
                                            <img className="transition-all" src={'/assets/icons/useful/user (3).png'} width={22} height={16} alt='' style={{ objectFit: 'contain' }} />
                                            <div className='mld-3'>
                                                <p className='text-smaller text-semibold'>{translate("Users perspective")}</p>
                                            </div>
                                        </div>
                                        <img className={"transition flexcc rotate-90-rev "} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                    </button>
                                </div>


                                <div className='pt-1 text-semibold ' style={{ borderTop: '1px solid #f0f0f0' }}>
                                    {/* <IntractionActionsList onClick={() => this.createProject()} language={this.props.language} data={{ title: 'New Frame', icon: importedIcons.plus }} /> */}
                                    <FramesPlusBut colors={this.props.colors} width={this.props.width} fullSize={true} type={'frame'} functionsHandler={this.props.functionsHandler} variables={this.props.variables} updateFrames={this.props.updateFrames} />

                                </div>

                                {/* {Array.isArray(this.props.sections) && this.props.sections?.map((section, i) => {

                                    return (
                                        <div key={i} className="w-100 py-2 bb-gray">

                                            <button className="flexcb w-100 p-2 hover-gray br-5" onClick={() => this.changeCollapse(section.key)}>
                                                <div className="flexc">
                                                    <p className="font-size-12 weight-500 main-c3 " style={{}}>{checkTranslation(section.name)}</p>
                                                </div>

                                                <div className='flexc'>
                                                    {section.addNew && (
                                                        <div className="mx-1" onClick={(e) => { e.stopPropagation(); this.handelFunction(section.addNew) }}>
                                                            <div className='br-20' style={{ background: '#ddd' }}>
                                                                <img className={"transition flexcc "} width={18} src='/assets/icons/plus.svg' />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="">
                                                        <img className={"transition flexcc " + ((this.state.collapses[section.key] == null || this.state.collapses[section.key] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                    </div>
                                                </div>
                                            </button>


                                            <Collapsible open={this.state.collapses[section.key] == null ? true : this.state.collapses[section.key]}>
                                                <div className='my-1'>
                                                    {this.props.modules?.map((item, index) => {
                                                        if (section.key == item.section && !item.hideInDashboard)
                                                            return (
                                                                <div className='w-100 my-1' key={index}>
                                                                    <button onClick={() => this.changeFrame(item)} className='flexc w-100 p-2 hover-gray br-5 transition-all'>
                                                                        <div className='flexcc'>
                                                                            <img className="transition-all" src={item.icon ?? '/assets/icons/applets/general/play-games.png'} height={22} />
                                                                        </div>

                                                                        <div className='mld-3'>
                                                                            <p className='font-size-12 main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            )
                                                    })}
                                                </div>
                                            </Collapsible>

                                        </div>
                                    )
                                })} */}

                            </div>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}
